<!--  -->
<template>
  <div>
    <el-table
      v-if="tableData.length!==0"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="activityName"
        label="活动名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="name"
        label="姓名"
        width="180"
      />
      <el-table-column
        prop="address"
        label="地址"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { readingarlist } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      platform: null, // 平台
      tableData: [],
      parmrs: {
        page: 1,
        pageSize: 10
      },
      total: null// 总页数
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.platform = val
      if (this.platform === 2) {
        this.readingarlistall()
      } else {
        this.tableData = []
      }
    },
    // 获取阅文列表
    async readingarlistall() {
      const data = await readingarlist(this.parmrs)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.pageSize = e
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    // 重置
    reset() {
      this.parmrs.page = 1
      this.parmrs.pageSize = 10
      if (this.platform === 2) {
        this.readingarlistall()
      }
    },
    choose(item) {
      console.log(item)
      this.$emit('close', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
